'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

export default function ConversionPricing() {
  const [showMessage, setShowMessage] = useState(false);

  return (
    <section
      className="py-24 lg:py-36"
      style={{ backgroundColor: 'var(--navy)' }}
      aria-label="Pricing"
    >
      <div className="max-w-screen-xl mx-auto px-6 lg:px-12 xl:px-20">
        <div className="max-w-md mx-auto text-center">
          {/* Amber label */}
          <p
            className="font-body text-xs uppercase tracking-widest mb-10"
            style={{ color: 'var(--amber)', letterSpacing: '0.14em' }}
          >
            A little something for deciding today.
          </p>

          {/* Prices */}
          <div className="flex items-baseline justify-center gap-4 mb-3">
            <span
              className="font-body text-2xl line-through"
              style={{ color: 'rgba(255,255,255,0.35)' }}
            >
              $79
            </span>
            <span
              className="font-display font-semibold"
              style={{ fontSize: 'clamp(3.5rem, 7vw, 5rem)', color: 'white', lineHeight: 1 }}
            >
              $67
            </span>
          </div>

          <p
            className="font-body text-sm italic mb-12"
            style={{ color: 'rgba(255,255,255,0.5)', lineHeight: '1.85' }}
          >
            15% off for joining now rather than later.
            No code needed. No deadline. Just the better price while you&rsquo;re here.
          </p>

          {/* CTA button */}
          <button
            onClick={() => setShowMessage(true)}
            className="group inline-flex items-center justify-center gap-2.5 w-full font-body font-semibold text-base py-4 px-8 rounded-xl transition-all duration-200 active:scale-95 mb-5"
            style={{ backgroundColor: 'var(--amber)', color: 'white' }}
            aria-label="Get full access for $67"
          >
            Get Full Access — $67
            <ArrowRight
              size={18}
              className="transition-transform duration-200 group-hover:translate-x-1"
              aria-hidden="true"
            />
          </button>

          {/* Inline message shown after button click */}
          {showMessage && (
            <div
              className="mb-5 px-5 py-4 rounded-xl text-left"
              style={{ backgroundColor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)' }}
            >
              <p className="font-body text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.85)', lineHeight: '1.75' }}>
                Secure checkout is almost ready. In the meantime, email{' '}
                <a
                  href="mailto:hello@thatclicked.com"
                  className="font-semibold underline"
                  style={{ color: 'var(--amber)' }}
                >
                  hello@thatclicked.com
                </a>{' '}
                to get access today.
              </p>
            </div>
          )}

          {/* Dismiss link */}
          <Link
            href="/free-lesson-screen"
            className="block w-full text-center font-body text-sm transition-opacity duration-150 hover:opacity-60 mb-8"
            style={{ color: 'rgba(255,255,255,0.45)' }}
            aria-label="Come back to this later and return to free lessons"
          >
            I&rsquo;ll come back to this later
          </Link>

          {/* Anna's dismissal note */}
          <div
            className="pt-6 border-t"
            style={{ borderColor: 'rgba(255,255,255,0.12)' }}
          >
            <p
              className="font-body text-xs italic text-center"
              style={{ color: 'rgba(255,255,255,0.45)', lineHeight: '1.75' }}
            >
              Completely fine if you do. The free lessons will always be here. And honestly, $79 is still fair — I just like rewarding people who back themselves early. That&rsquo;s all this is.
            </p>
            <p
              className="font-body text-xs italic text-center mt-2"
              style={{ color: 'rgba(255,255,255,0.3)' }}
            >
              — A
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}